import { useSelector } from 'react-redux'

import { useTimer, ETimerVariant } from 'hooks'
import { TimerContainer } from '../timer-container'
import { useMobileScreen } from 'primsell-shared-layer/hooks'
import { campaignPublicSelector } from 'primsell-shared-layer/features'

const IsNotStartedTimer = (): JSX.Element | null => {
  const isMobile = useMobileScreen()
  const publicCampaignDetails = useSelector(campaignPublicSelector)
  const startDate = publicCampaignDetails?.startDate || ''
  const isNotStarted = new Date(startDate).getTime() > new Date().getTime()

  const { timeLeft } = useTimer({ startTime: startDate, variant: ETimerVariant.Secondary })

  if (!isNotStarted) {
    return null
  }

  return (
    <TimerContainer
      leftString={`
          The campaign will start in
          ${isMobile ? '<br />' : ' '}
          ${timeLeft}`}
    />
  )
}

export { IsNotStartedTimer }
